<template>
  <div class="gm-page gm-impersonate-page">
    <form class="gm-panel gm-impersonate-panel" @submit.prevent="impersonateUser">
      <p class="gm-eyebrow">Session / Play As</p>
      <h2 class="gm-title">Game Master Impersonation</h2>
      <p class="gm-impersonate-hint">
        Hands the app a different user's access token so you play the session as them.
      </p>

      <div v-if="errorMessage" class="gm-impersonate-error">{{ errorMessage }}</div>

      <div class="gm-field">
        <label for="token" class="gm-label">User Access Token</label>
        <textarea
          id="token"
          v-model="token"
          class="gm-textarea gm-impersonate-token"
          placeholder="Paste the user access token here for impersonation"
          required
          rows="5"
        ></textarea>
      </div>

      <div class="gm-impersonate-actions">
        <button type="submit" class="gm-btn gm-btn--primary">Impersonate User</button>
      </div>
    </form>
  </div>
</template>

<script>
export default {
  name: "GameMasterImpersonate",
  data() {
    return {
      token: "",
      errorMessage: null,
    };
  },
  methods: {
    async impersonateUser() {
      try {
        if (!this.token.trim()) {
          this.errorMessage = "Please enter a valid user access token.";
          return;
        }

        // Dispatch the login action with the user's token for impersonation
        this.$store.dispatch("login", { token: this.token.trim() });

        // Redirect to the Game Master main page
        this.$router.push({ name: "GameMaster" });
      } catch (error) {
        this.errorMessage = "Invalid token or impersonation failed.";
        console.error("Impersonation error:", error);
      }
    },
  },
};
</script>

<style scoped>
.gm-impersonate-page {
  align-items: center;
  justify-content: center;
  padding: var(--gm-gap-lg);
  padding-bottom: calc(var(--gm-gap-lg) + var(--gm-dock-clearance));
}

.gm-impersonate-panel {
  display: flex;
  flex-direction: column;
  gap: var(--gm-gap);
  width: 100%;
  max-width: 28rem;
}

.gm-title {
  text-align: center;
}

.gm-impersonate-hint {
  margin: -0.25rem 0 0;
  text-align: center;
  font-size: 0.8rem;
  color: var(--gm-text-muted);
}

.gm-impersonate-error {
  padding: 0.6rem 0.75rem;
  background: rgba(201, 69, 63, 0.12);
  border: 1px solid rgba(201, 69, 63, 0.4);
  border-radius: var(--gm-radius-sm);
  color: var(--gm-danger);
  font-size: 0.8rem;
}

.gm-impersonate-token {
  font-family: 'Roboto Mono', 'Courier New', monospace;
  resize: vertical;
}

.gm-impersonate-actions {
  display: flex;
  justify-content: center;
}

.gm-impersonate-actions .gm-btn {
  min-width: 12rem;
}
</style>
